import "./src/styles/global.scss";

export const onInitialClientRender = () => {
  const popup = document.querySelector(".homepopup");

  if (popup !== null) {
    popup.classList.add("homepopup--active");
  }
};
